export const RECORDS_PER_PAGE = 10
export const SEARCH_TYPES = [
  {
    name: 'RUT',
    value: 1
  },
  {
    name: 'Razón Social',
    value: 2
  }
]

export const SEARCH_FILTER_RUT = 1
export const SEARCH_FILTER_NAME = 2
